import { combineReducers } from 'redux';
import getCorporateClients from 'store/reducers/corporate-client/get-corporate-clients';
import postCorporateClient from 'store/reducers/corporate-client/post-corporate-client';
import getCorporateClient from 'store/reducers/corporate-client/get-corporate-client';
import deleteCorporateClient from 'store/reducers/corporate-client/delete-corporate-client';

export default combineReducers({
  getCorporateClients,
  postCorporateClient,
  getCorporateClient,
  deleteCorporateClient,
});
